import { startsWith } from 'lodash';
import { TouchEvent } from 'react';

export default (e: unknown): e is TouchEvent<any> =>
  e && (e as any).type && startsWith((e as any).type, 'touch');
